// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Background-BackgroundBlock-module--cls1--2uvLh","cls2":"Background-BackgroundBlock-module--cls2--3pocD Background-BackgroundBlock-module--cls1--2uvLh"};